export const SORT_ORDER_OPTIONS = [
  {
    label: 'Start ascending',
    property: 'start',
    direction: 'ASC'
  },
  {
    label: 'Start descending',
    property: 'start',
    direction: 'DESC'
  },
  {
    label: 'End ascending',
    property: 'end',
    direction: 'ASC'
  },
  {
    label: 'End descending',
    property: 'end',
    direction: 'DESC'
  }
];

export const TIMELIST_TYPE = 'timelist';

export const CURRENT_CSS_SUFFIX = '--is-current';
export const PAST_CSS_SUFFIX = '--is-past';
export const FUTURE_CSS_SUFFIX = '--is-future';
